export default "__VITE_ASSET__6c461209__"